import {Card, CardBody, CardHeader, Col, Modal} from "reactstrap";
import {CustomBadge, CustomHeader, CustomReactStrapInput} from "@pages/new-design-components/custom-components";
import {calculateSum, checkAndFormatShortGb, formatDateShortGB} from "@constants/index";
import CustomDropdownComponent from "@pages/components/JobDetailsComponents/CustomInspectionDropDown";
import IcoMoon from "react-icomoon";
import IconSet from "@assets/selection.json";
import React, {useState} from "react";
import {ButtonContainer} from "@pages/reusable-components/styled-components";
import axios from "axios";
import moment from "moment/moment";
import DatePicker from "react-datepicker";
import notify from "@utils/notify";
export default function CustomerOverviewInfo({debts,xeroCustomerData,customerData,updateXeroCustomerData}) {
    const [openModal, setOpenModal] = useState({show:false,title: 'Status'})
    const [updatableValues, setUpdatableValues] = useState({});

    const toggleModal = () => {
        setOpenModal({show: !openModal.show})
    }
    const updateCustomerStatus = () => {
        axios({
            method: 'POST',
            url: `/debt-customer/${customerData.id}`,
            data:  updatableValues,
        })
            .then(() => {
                setOpenModal({show:false});
                updateXeroCustomerData({...xeroCustomerData, ...updatableValues });
                setUpdatableValues({});
                notify.success('Customer successfully updated');
                window.location.reload();
            }).catch(()=>{
            notify.warning('Error updating customer');
            setUpdatableValues({})
            setOpenModal({show:false})
        });
    }


    return (
      <>
          <Modal
              isOpen={openModal.show}
              toggle={toggleModal}
              className="modal-dialog-centered"
          >
              <div className={'p-3'}>
                  <h6 className="modal-title main-color">Update Customer {openModal.title}</h6>
              </div>

              <div className="modal-footer justify-content-end">
                  <ButtonContainer
                      onClick={() => {
                          setUpdatableValues({})
                          setOpenModal({show: false})
                      }}
                  >
                      {`Close`}
                  </ButtonContainer>
                  <ButtonContainer
                      reverse
                      onClick={() => {
                          updateCustomerStatus()
                      }}
                  >
                      {`Update`}
                  </ButtonContainer>

              </div>
          </Modal>
          <Col lg={3}>
              <Card className={'fleet-details-container'}>
                  <CardHeader>
                      <CustomHeader fontSize={'14px'}  weight={'400'}>
                          Total Number of late payments
                      </CustomHeader>
                      <CustomHeader lineHeight={'16px'} weight={'700'} color={'#000'} fontSize={'20px'}>{debts.filter(item=>!item?.paid_date)?.length}</CustomHeader>

                      <CustomHeader fontSize={'14px'}  weight={'400'}>
                          Overdue Amount
                      </CustomHeader>

                      <CustomHeader>
                          £{calculateSum({data: debts,key:'amount_due'})?.toFixed(2)}
                      </CustomHeader>
                      {customerData.deals.length ? '' :  <CustomBadge>No Deal</CustomBadge> }

                  </CardHeader>
                  <CardBody>
                      <CustomHeader fontSize={'14px'}  weight={'700'}>
                          Account Status:
                      </CustomHeader>
                      <CustomHeader fontSize={'14px'}  weight={'700'}>
                          <CustomDropdownComponent
                              withoutDot
                              buttonHeight={'100%'}
                              border={'null'}
                              selectedTitle={xeroCustomerData?.customer_status}
                              statusArrayKey={'debtAccountStatuses'}
                              noBadge={true}
                              handleChange={(value)=>{
                                  setUpdatableValues({...updatableValues,customer_status:value})
                                  setOpenModal({show: true, title: 'Account Status'})
                              }}
                          />
                      </CustomHeader>
                      {xeroCustomerData?.customer_status === 'overdue' && <>
                          <CustomHeader fontSize={'14px'} weight={'700'}>
                              Status:
                          </CustomHeader>
                          <CustomHeader fontSize={'14px'} weight={'700'}>
                              <CustomDropdownComponent
                                  withoutDot
                                  buttonHeight={'100%'}
                                  border={'null'}
                                  selectedTitle={xeroCustomerData?.status}
                                  statusArrayKey={'debtListStatuses'}
                                  noBadge={true}
                                  handleChange={(value) => {
                                      setUpdatableValues({...updatableValues, status: value})
                                      setOpenModal({show: true, title: 'Status'})
                                  }}
                              />
                          </CustomHeader>
                          <CustomHeader fontSize={'14px'}  weight={'700'}>
                              Expected Payment Date:
                          </CustomHeader>
                          <CustomHeader fontSize={'14px'}  weight={'700'}>
                              <CustomReactStrapInput
                                  border={'1px solid #f7fafc'}
                                  borderBottom={'1px solid #f7fafc'}
                                  onChange={(e) => {
                                      if (e.target.value === '') {
                                          setUpdatableValues({...updatableValues,expected_payment_date: null})
                                      } else {
                                          setUpdatableValues({...updatableValues,expected_payment_date: moment(e.target.value).format('YYYY-MM-DD')})
                                      }
                                      setOpenModal({show: true, title: 'Expected Payment Date'})
                                  }}
                                  value={xeroCustomerData.expected_payment_date ? checkAndFormatShortGb(xeroCustomerData.expected_payment_date) : ''}
                                  type={'date'}
                                  radius={'none'}
                              />

                          </CustomHeader>
                      </>}

                  </CardBody>
                  <CardHeader className={'border-bottom-0'}>

                      <div className={'d-flex justify-content-between'}>
                          <CustomHeader fontSize={'16px'}>
                              Customer Details
                          </CustomHeader>
                      </div>
                  </CardHeader>
                  <CardBody>
                      <div className={'d-flex g-5'}>
                          <IcoMoon
                              className={'cursor-pointer'}
                              iconSet={IconSet}
                              icon={'re_user'}
                              size={25}
                          />
                          <CustomHeader fontSize={'14px'}  weight={'700'}>
                              Contact Information:
                          </CustomHeader>
                      </div>
                      <div className={'ml-3'}>
                          <div className={'d-flex flex-column'}>
                              <CustomHeader weight={'700'} color={'#74787E'} fontSize={'14px'} className={'mb-0'}>
                                  Title:
                              </CustomHeader>
                              <CustomHeader fontSize={'14px'} weight={'400'} color={'#000000'}>
                                  {customerData?.title?.toUpperCase()}
                              </CustomHeader>
                          </div>
                          <div className={'d-flex flex-column'}>
                              <CustomHeader fontSize={'14px'} weight={'700'} color={'#74787E'} className={'mb-0'}>
                                  Name:
                              </CustomHeader>
                              <CustomHeader fontSize={'14px'} weight={'400'} color={'#000000'}>
                                  {customerData?.full_name}
                              </CustomHeader>
                          </div>
                          <div className={'d-flex flex-column'}>
                              <CustomHeader weight={'700'} color={'#74787E'} fontSize={'14px'} className={'mb-0'}>
                                  Email:
                              </CustomHeader>
                              <CustomHeader fontSize={'14px'} weight={'400'} color={'#000000'}>
                                  {customerData?.email}
                              </CustomHeader>
                          </div>
                          <div className={'d-flex flex-column'}>
                              <CustomHeader weight={'700'} color={'#74787E'} fontSize={'14px'} className={'mb-0'}>
                                  Mobile:
                              </CustomHeader>
                              <CustomHeader fontSize={'14px'} weight={'400'} color={'#000000'}>
                                  {customerData?.mobile_number}
                              </CustomHeader>
                          </div>
                          <div className={'d-flex flex-column'}>
                              <CustomHeader weight={'700'} color={'#74787E'} fontSize={'14px'} className={'mb-0'}>
                                  Landline:
                              </CustomHeader>
                              <CustomHeader fontSize={'14px'} weight={'400'} color={'#000000'}>
                                  {customerData?.land_line_number ?? '-'}
                              </CustomHeader>
                          </div>
                      </div>
                      <div className={'d-flex g-5'}>
                          <IcoMoon
                              className={'cursor-pointer department-icon'}
                              iconSet={IconSet}
                              icon={'location'}
                              size={25}
                          />
                          <CustomHeader fontSize={'14px'}  weight={'700'}>
                              Address Information:
                          </CustomHeader>
                      </div>
                      <div className={'ml-3'}>
                          <div className={'d-flex flex-column'}>
                              <CustomHeader weight={'700'} color={'#74787E'} fontSize={'14px'} className={'mb-0'}>
                                  Address:
                              </CustomHeader>
                              <CustomHeader fontSize={'14px'} weight={'400'} color={'#000000'}>
                                  {customerData?.address ?? '-'}
                              </CustomHeader>
                          </div>
                          <div className={'d-flex flex-column'}>
                              <CustomHeader weight={'700'} color={'#74787E'} fontSize={'14px'} className={'mb-0'}>
                                  Property Status:
                              </CustomHeader>
                              <CustomHeader fontSize={'14px'} weight={'400'} color={'#000000'}>
                                  {'-'}
                              </CustomHeader>
                          </div>
                      </div>
                      <div className={'d-flex g-5'}>
                          <IcoMoon
                              className={'cursor-pointer'}
                              iconSet={IconSet}
                              icon={'re_bank'}
                              size={25}
                          />
                          <CustomHeader fontSize={'14px'}  weight={'700'}>
                              Bank Information:
                          </CustomHeader>
                      </div>

                      <div className={'d-flex flex-column ml-3'}>
                          <CustomHeader fontSize={'14px'} weight={'400'} color={'#000000'}>
                              {customerData?.bank_name}
                          </CustomHeader>
                          <CustomHeader fontSize={'14px'} weight={'400'} color={'#000000'}>
                              {customerData?.bank_account_name}
                          </CustomHeader>
                          <CustomHeader fontSize={'14px'} weight={'400'} color={'#000000'}>
                              {customerData?.bank_account_number}
                          </CustomHeader>
                          <CustomHeader fontSize={'14px'} weight={'400'} color={'#000000'}>
                              {customerData?.bank_sort_code}
                          </CustomHeader>
                      </div>
                      <div className={'d-flex g-5'}>
                          <IcoMoon
                              className={'cursor-pointer'}
                              iconSet={IconSet}
                              icon={'re_Car'}
                              size={25}
                          />
                          <CustomHeader fontSize={'14px'}  weight={'700'}>
                              Driver License:
                          </CustomHeader>
                      </div>

                      <div className={'ml-3'}>
                          <div className={'d-flex flex-column'}>
                              <CustomHeader weight={'700'} color={'#74787E'} fontSize={'14px'} className={'mb-0'}>
                                  Number:
                              </CustomHeader>
                              <CustomHeader fontSize={'14px'} weight={'400'} color={'#000000'}>
                                  {customerData?.driver_license_number}
                              </CustomHeader>
                          </div>
                          <div className={'d-flex flex-column'}>
                              <CustomHeader weight={'700'} color={'#74787E'} fontSize={'14px'} className={'mb-0'}>
                                  Country of Issue:
                              </CustomHeader>
                              <CustomHeader fontSize={'14px'} weight={'400'} color={'#000000'}>
                                  {customerData?.country_of_issue}
                              </CustomHeader>
                          </div>
                          <div className={'d-flex flex-column'}>
                              <CustomHeader weight={'700'} color={'#74787E'} fontSize={'14px'} className={'mb-0'}>
                                  Issue Date:
                              </CustomHeader>
                              <CustomHeader fontSize={'14px'} weight={'400'} color={'#000000'}>
                                  {customerData?.licence_issue_date}
                              </CustomHeader>
                          </div>
                          <div className={'d-flex flex-column'}>
                              <CustomHeader weight={'700'} color={'#74787E'} fontSize={'14px'} className={'mb-0'}>
                                  Expiry Date:
                              </CustomHeader>
                              <CustomHeader fontSize={'14px'} weight={'400'} color={'#000000'}>
                                  {customerData?.licence_expiry_date}
                              </CustomHeader>
                          </div>
                      </div>

                  </CardBody>
              </Card>
          </Col>
      </>
    )
}